import React from 'react';
import { FormattedMessage } from 'react-intl';
import OTButton from '../tag/OTButton';
import OTIcon from '../tag/OTIcon';
import Notification from '../Notification';
import WindowUtils from '../../utils/WindowUtils';

const { id: module_id } = module;

const CoronaQuestionnaireNotification = () => {
  return (
    <Notification>
      <OTIcon
        className="ot-notification__icon"
        config={{ type: 'custom', name: 'kyselyt', color: 'darkblue' }}
        style={{ marginRight: '20px', height: '17px' }}
      />
      <h2 className="ot-notification__header">
        <FormattedMessage id={`${module_id}.header`} />
      </h2>

      <p className="ot-notification__description">
        <FormattedMessage
          id={`${module_id}.body`}
          values={{
            br: <br />,
          }}
        />
      </p>

      <p className="ot-notification__description">
        <FormattedMessage id={`${module_id}.desc`} />
      </p>
      <OTButton
        onClick={() => WindowUtils.navigate('#/questionnaires/covid19')}
      >
        <FormattedMessage id={'fill'} />
      </OTButton>
    </Notification>
  );
};

export default CoronaQuestionnaireNotification;
